import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { compose, setDisplayName } from 'react-recompose';

import {
  CAMINO_EVENTS_HE,
  CAMINO_SUBSCRIPTION,
  REP_VISITS_SUBSCRIPTION,
} from '../Authorization/constants';
import messages from './messages';
import Grid from '../../components/Grid';
import CollegeEventFilterContainer from '../CollegeEventFilter';
import { withEnabledFeatures } from '../../utils/features';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';

import './styles.css';

const getDescription = (isCaminoEventsEnabled, hasCaminoSubscription) => (
  <div id="description" styleName="audience">
    Events are visible to all students{' '}
    {isCaminoEventsEnabled ? (
      <React.Fragment>
        in <strong>Naviance </strong>
      </React.Fragment>
    ) : (
      ''
    )}
    with Events enabled. Using a Filter will&nbsp;
    <strong>Recommend</strong>
    &nbsp;your event to a particular group of students.
    {isCaminoEventsEnabled && hasCaminoSubscription ? (
      <strong> Filters do not apply to events in Camino.</strong>
    ) : (
      ''
    )}
  </div>
);

const EventAudienceComponent = ({
  intl,
  action,
  heAccount,
  onFilterChange,
  enabledFeatures,
  collegeEventFilter,
}) => {
  const isCaminoEventsEnabled = useMemo(
    () => enabledFeatures && enabledFeatures.includes(CAMINO_EVENTS_HE),
    [enabledFeatures],
  );
  const hasSubscription = useCallback(
    (subscription) =>
      heAccount && heAccount.activeSubscriptions.includes(subscription),
    [heAccount],
  );

  if (isCaminoEventsEnabled && !hasSubscription(REP_VISITS_SUBSCRIPTION)) {
    return null;
  }

  return (
    <Grid.Row data-cy="college-events-edit-form-event-audience">
      <Grid.Column width={16} styleName="event-details">
        <label htmlFor="collegeEventFilter">
          <FormattedMessage {...messages.editEventFilter} />
        </label>
        {getDescription(
          isCaminoEventsEnabled,
          hasSubscription(CAMINO_SUBSCRIPTION),
        )}
      </Grid.Column>
      {action === 'details' ? (
        <div styleName="data-not-dropdown">
          {collegeEventFilter ?
            collegeEventFilter.name :
            'filter name not found'}
        </div>
      ) : (
        <Grid.Column width={7} styleName="dropsearch">
          <CollegeEventFilterContainer
            id="collegeEventFilter"
            aria-labelledby={intl.formatMessage(messages.editEventFilter)}
            name="collegeEventFilter"
            onSelectionChange={onFilterChange}
            selectedFilter={collegeEventFilter}
          />
        </Grid.Column>
      )}
    </Grid.Row>
  );
};

EventAudienceComponent.propTypes = {
  intl: PropTypes.object,
  action: PropTypes.string,
  heAccount: PropTypes.object,
  onFilterChange: PropTypes.func,
  collegeEventFilter: PropTypes.object,
  enabledFeatures: PropTypes.arrayOf(PropTypes.string),
};
export default compose(
  setDisplayName('EventAudience'),
  withEnabledFeatures,
  withHEAccountSubscriptions,
)(EventAudienceComponent);
